import { cn } from "@/lib/utils";

// Who sells the addon (MPL-3832). The addon catalog of a diet mixes the
// catering's own addons with Foodango products of other merchants, so every
// card and row names the seller above the addon name. `name` is the catalog's
// `merchantName`; rows from before the merchant sync have none and fall back to
// the diet's catering, which is who sells them. Renders nothing when neither
// is known — a missing seller must not break the view.
export const AddonSellerName = ({
  name,
  fallback,
  className,
}: {
  name?: string | null;
  fallback?: string;
  className?: string;
}) => {
  const seller = name ?? fallback;
  if (!seller) {
    return null;
  }

  return (
    <p
      className={cn(
        // DS: 14px regular, 22px line height, text-subtle (#6b6b6b).
        "truncate text-brand-black-100 text-sm leading-5.5",
        className,
      )}
    >
      {seller}
    </p>
  );
};
